import * as React from 'react';
import {Image} from 'antd';
import image from '../../../img/party.png';

export default function PartyIcon() {
  return <Image width={80} src={image} preview={false}/>;
}
